import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, vShow as _vShow, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-466a4624"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-organization-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add School", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Add New School", -1))
const _hoisted_5 = { class: "steps-indicator" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "step-number" }
const _hoisted_8 = {
  key: 0,
  class: "checkmark"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "step-label" }
const _hoisted_11 = { class: "form-step" }
const _hoisted_12 = { class: "form-section" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Basic Information", -1))
const _hoisted_14 = { class: "form-grid" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "School Name", -1))
const _hoisted_17 = {
  key: 0,
  class: "error-message"
}
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "districtName" }, "District", -1))
const _hoisted_20 = { class: "district-select-container" }
const _hoisted_21 = { class: "district-input-wrapper" }
const _hoisted_22 = ["placeholder"]
const _hoisted_23 = {
  key: 0,
  class: "district-dropdown"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "selected-district-badge"
}
const _hoisted_26 = {
  key: 0,
  class: "error-message"
}
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "organizationType" }, "Type", -1))
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-466a4624>Select Type</option><option value=\"Elementary\" data-v-466a4624>Elementary School</option><option value=\"Middle\" data-v-466a4624>Middle School</option><option value=\"High\" data-v-466a4624>High School</option><option value=\"Charter\" data-v-466a4624>Charter School</option><option value=\"Private\" data-v-466a4624>Private School</option>", 6)
const _hoisted_35 = [
  _hoisted_29
]
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "organizationCode" }, "School Code", -1))
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = { class: "checkbox-label" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Active School", -1))
const _hoisted_41 = { class: "form-section" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "School Hours", -1))
const _hoisted_43 = { class: "form-grid" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Default Start Time", -1))
const _hoisted_46 = {
  key: 0,
  class: "error-message"
}
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Default End Time", -1))
const _hoisted_49 = {
  key: 0,
  class: "error-message"
}
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Early Dismissal Start Time", -1))
const _hoisted_52 = {
  key: 0,
  class: "error-message"
}
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Early Dismissal End Time", -1))
const _hoisted_55 = {
  key: 0,
  class: "error-message"
}
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Emergency Start Time", -1))
const _hoisted_58 = {
  key: 0,
  class: "error-message"
}
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Emergency End Time", -1))
const _hoisted_61 = {
  key: 0,
  class: "error-message"
}
const _hoisted_62 = { class: "form-group" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Shortened Day Start Time", -1))
const _hoisted_64 = {
  key: 0,
  class: "error-message"
}
const _hoisted_65 = { class: "form-group" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Shortened Day End Time", -1))
const _hoisted_67 = {
  key: 0,
  class: "error-message"
}
const _hoisted_68 = { class: "form-section" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contact Information", -1))
const _hoisted_70 = { class: "form-grid" }
const _hoisted_71 = { class: "form-group full-width" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Street Address", -1))
const _hoisted_73 = { class: "address-input-container" }
const _hoisted_74 = {
  key: 0,
  class: "address-suggestions"
}
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "city" }, "City", -1))
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "state" }, "State", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select State", -1))
const _hoisted_80 = ["value"]
const _hoisted_81 = { class: "form-group" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "zipcode" }, "ZIP Code", -1))
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Phone", -1))
const _hoisted_85 = { class: "form-group" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "website" }, "Website", -1))
const _hoisted_87 = { class: "form-step" }
const _hoisted_88 = { class: "form-section" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Grade Levels", -1))
const _hoisted_90 = { class: "grades-grid" }
const _hoisted_91 = ["for"]
const _hoisted_92 = ["onUpdate:modelValue", "id"]
const _hoisted_93 = { class: "grade-name" }
const _hoisted_94 = { class: "form-step" }
const _hoisted_95 = { class: "form-section" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Geographic Location", -1))
const _hoisted_97 = { class: "form-grid" }
const _hoisted_98 = { class: "form-group" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "latitude" }, "Latitude", -1))
const _hoisted_100 = { class: "form-group" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "longitude" }, "Longitude", -1))
const _hoisted_102 = { class: "form-step" }
const _hoisted_103 = { class: "form-section" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Student Groups", -1))
const _hoisted_105 = { class: "groups-container" }
const _hoisted_106 = { class: "group-header" }
const _hoisted_107 = ["onClick"]
const _hoisted_108 = { class: "group-content" }
const _hoisted_109 = { class: "form-group" }
const _hoisted_110 = ["for"]
const _hoisted_111 = ["onUpdate:modelValue", "id"]
const _hoisted_112 = { class: "form-grid" }
const _hoisted_113 = { class: "form-group" }
const _hoisted_114 = ["for"]
const _hoisted_115 = ["onUpdate:modelValue", "id", "name"]
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = ["for"]
const _hoisted_118 = ["onUpdate:modelValue", "id", "name"]
const _hoisted_119 = { class: "form-grid" }
const _hoisted_120 = { class: "form-group" }
const _hoisted_121 = ["for"]
const _hoisted_122 = ["onUpdate:modelValue", "id"]
const _hoisted_123 = { class: "form-group" }
const _hoisted_124 = ["for"]
const _hoisted_125 = ["onUpdate:modelValue", "id"]
const _hoisted_126 = { class: "form-group" }
const _hoisted_127 = ["for"]
const _hoisted_128 = ["onUpdate:modelValue", "id"]
const _hoisted_129 = { class: "form-group" }
const _hoisted_130 = ["for"]
const _hoisted_131 = ["onUpdate:modelValue", "id"]
const _hoisted_132 = { class: "form-navigation" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button-icon" }, "←", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "button-icon" }, "→", -1))
const _hoisted_135 = {
  key: 2,
  type: "submit",
  class: "submit-button"
}

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { API_URL } from "../config";
import { Loader } from "@googlemaps/js-api-loader";

// Declare Google Maps types
declare global {
  interface Window {
    google: typeof google;
  }
}

interface Group {
  name: string;
  pickupNotes: string;
  dropOffNotes: string;
  bellTime: string;
  dismissalTime: string;
  startDate: string;
  endDate: string;
}

interface Organization {
  id: number;
  districtName: string;
  name: string;
  organizationType: string;
  organizationCode: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  phone: string;
  website: string;
  defaultStartTime: string;
  defaultEndTime: string;
  earlyDismissalStartTime: string;
  earlyDismissalEndTime: string;
  emergencyStartTime: string;
  emergencyEndTime: string;
  shortenedDayStartTime: string;
  shortenedDayEndTime: string;
  isActive: boolean;
  prekindergarten: number;
  kindergarten: number;
  grade1: number;
  grade2: number;
  grade3: number;
  grade4: number;
  grade5: number;
  grade6: number;
  grade7: number;
  grade8: number;
  grade9: number;
  grade10: number;
  grade11: number;
  grade12: number;
  latitude: string;
  longitude: string;
  groups: Group[];
}

interface GradeOption {
  key: keyof Organization;
  label: string;
}

interface District {
  id: number;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddOrganization',
  setup(__props) {

const router = useRouter();
const googleMapsApiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
const addressInput = ref<HTMLInputElement | null>(null);
const autocomplete = ref<google.maps.places.Autocomplete | null>(null);
const districts = ref<District[]>([]);
const districtSearch = ref("");
const showDistrictDropdown = ref(false);

const organization = ref<Organization>({
  id: 0,
  districtName: "",
  name: "",
  organizationType: "",
  organizationCode: "",
  address: "",
  city: "",
  state: "",
  zipcode: "",
  phone: "",
  website: "",
  defaultStartTime: "",
  defaultEndTime: "",
  earlyDismissalStartTime: "",
  earlyDismissalEndTime: "",
  emergencyStartTime: "",
  emergencyEndTime: "",
  shortenedDayStartTime: "",
  shortenedDayEndTime: "",
  isActive: true,
  prekindergarten: 0,
  kindergarten: 0,
  grade1: 0,
  grade2: 0,
  grade3: 0,
  grade4: 0,
  grade5: 0,
  grade6: 0,
  grade7: 0,
  grade8: 0,
  grade9: 0,
  grade10: 0,
  grade11: 0,
  grade12: 0,
  latitude: "0",
  longitude: "0",
  groups: [],
});

const errors = ref<{ [key: string]: string }>({
  name: "",
  city: "",
  districtName: "",
  organizationType: "",
  organizationCode: "",
  address: "",
  state: "",
  zipcode: "",
  phone: "",
  defaultStartTime: "",
  defaultEndTime: "",
  earlyDismissalStartTime: "",
  earlyDismissalEndTime: "",
  emergencyStartTime: "",
  emergencyEndTime: "",
  shortenedDayStartTime: "",
  shortenedDayEndTime: "",
});

const selectedTab = ref("general");

const tabs = [
  { id: "general", number: 1, label: "General Info" },
  { id: "grades", number: 2, label: "Grades" },
  { id: "location", number: 3, label: "Location" },
  { id: "groups", number: 4, label: "Groups" },
];

const gradesList: GradeOption[] = [
  { key: "prekindergarten", label: "Pre-K" },
  { key: "kindergarten", label: "Kindergarten" },
  { key: "grade1", label: "Grade 1" },
  { key: "grade2", label: "Grade 2" },
  { key: "grade3", label: "Grade 3" },
  { key: "grade4", label: "Grade 4" },
  { key: "grade5", label: "Grade 5" },
  { key: "grade6", label: "Grade 6" },
  { key: "grade7", label: "Grade 7" },
  { key: "grade8", label: "Grade 8" },
  { key: "grade9", label: "Grade 9" },
  { key: "grade10", label: "Grade 10" },
  { key: "grade11", label: "Grade 11" },
  { key: "grade12", label: "Grade 12" },
];

const states = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

// Add computed property for filtered and sorted districts
const filteredDistricts = computed(() => {
  return districts.value
    .filter((district) =>
      district.name.toLowerCase().includes(districtSearch.value.toLowerCase())
    )
    .sort((a, b) => a.name.localeCompare(b.name));
});

// Add method to handle district selection
const selectDistrict = (district: District) => {
  organization.value.districtName = district.name;
  showDistrictDropdown.value = false;
  districtSearch.value = "";
  errors.value.districtName = "";
};

// Add method to toggle district dropdown
const toggleDistrictDropdown = () => {
  showDistrictDropdown.value = !showDistrictDropdown.value;
};

const fetchDistricts = async () => {
  try {
    const response = await fetch(`${API_URL}/districts`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    if (response.ok) {
      districts.value = await response.json();
    } else {
      console.error("Failed to fetch districts:", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching districts:", error);
  }
};

onMounted(async () => {
  await fetchDistricts();

  // Add click outside handler for district dropdown
  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest(".district-select-container")) {
      showDistrictDropdown.value = false;
    }
  });

  if (googleMapsApiKey) {
    const loader = new Loader({
      apiKey: googleMapsApiKey,
      version: "weekly",
      libraries: ["places"],
    });

    try {
      await loader.load();
      if (addressInput.value) {
        autocomplete.value = new google.maps.places.Autocomplete(
          addressInput.value,
          {
            componentRestrictions: { country: "us" },
            fields: ["address_components", "geometry", "formatted_address"],
          }
        );

        autocomplete.value.addListener("place_changed", () => {
          const place = autocomplete.value?.getPlace();
          if (place && place.geometry) {
            // Update address fields
            const addressComponents = place.address_components || [];
            const streetNumber =
              addressComponents.find((c) => c.types.includes("street_number"))
                ?.long_name || "";
            const route =
              addressComponents.find((c) => c.types.includes("route"))
                ?.long_name || "";
            organization.value.address = `${streetNumber} ${route}`.trim();

            organization.value.city =
              addressComponents.find((c) => c.types.includes("locality"))
                ?.long_name || "";
            organization.value.state =
              addressComponents.find((c) =>
                c.types.includes("administrative_area_level_1")
              )?.short_name || "";
            organization.value.zipcode =
              addressComponents.find((c) => c.types.includes("postal_code"))
                ?.long_name || "";

            // Update coordinates
            const location = place.geometry?.location;
            if (location) {
              organization.value.latitude = location.lat().toString();
              organization.value.longitude = location.lng().toString();
            }
          }
        });
      }
    } catch (error) {
      console.error("Error loading Google Maps:", error);
    }
  }
});

const createOrganization = async () => {
  if (!validateForm() || !validateTimeFields()) {
    selectedTab.value = "general";
    errors.value.form = "Please fill in all required time fields.";
    return;
  }

  try {
    const response = await fetch(`${API_URL}/organizations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(organization.value),
    });

    if (response.ok) {
      const newOrganization = await response.json();
      router.push(`/organizations/${newOrganization.id}`);
    } else {
      const error = await response.json();
      alert(
        `Failed to create organization: ${error.message || response.statusText}`
      );
    }
  } catch (error) {
    console.error("Error creating organization:", error);
    alert("An error occurred while creating the organization.");
  }
};

const addGroup = () => {
  organization.value.groups.push({
    name: "",
    pickupNotes: "",
    dropOffNotes: "",
    bellTime: "",
    dismissalTime: "",
    startDate: "",
    endDate: "",
  });
};

const removeGroup = (index: number) => {
  organization.value.groups.splice(index, 1);
};

const currentTabIndex = computed(() => {
  return tabs.findIndex((tab) => tab.id === selectedTab.value);
});

const isFirstTab = computed(() => currentTabIndex.value === 0);
const isLastTab = computed(() => currentTabIndex.value === tabs.length - 1);

const previousTab = () => {
  if (!isFirstTab.value) {
    selectedTab.value = tabs[currentTabIndex.value - 1].id;
  }
};

const nextTab = () => {
  if (!isLastTab.value) {
    selectedTab.value = tabs[currentTabIndex.value + 1].id;
  }
};

const validateForm = () => {
  let isValid = true;
  errors.value = {
    name: "",
    city: "",
    districtName: "",
    organizationType: "",
    organizationCode: "",
    address: "",
    state: "",
    zipcode: "",
    phone: "",
    defaultStartTime: "",
    defaultEndTime: "",
    earlyDismissalStartTime: "",
    earlyDismissalEndTime: "",
    emergencyStartTime: "",
    emergencyEndTime: "",
    shortenedDayStartTime: "",
    shortenedDayEndTime: "",
  };

  // Required fields validation
  if (!organization.value.name.trim()) {
    errors.value.name = "School name is required";
    isValid = false;
  }

  if (!organization.value.city.trim()) {
    errors.value.city = "City is required";
    isValid = false;
  }

  if (!organization.value.districtName) {
    errors.value.districtName = "District is required";
    isValid = false;
  }

  if (!organization.value.organizationType) {
    errors.value.organizationType = "Organization type is required";
    isValid = false;
  }

  if (!organization.value.organizationCode.trim()) {
    errors.value.organizationCode = "Organization code is required";
    isValid = false;
  }

  if (!organization.value.address.trim()) {
    errors.value.address = "Address is required";
    isValid = false;
  }

  if (!organization.value.state) {
    errors.value.state = "State is required";
    isValid = false;
  }

  if (!organization.value.zipcode.trim()) {
    errors.value.zipcode = "ZIP code is required";
    isValid = false;
  }

  if (!organization.value.phone.trim()) {
    errors.value.phone = "Phone number is required";
    isValid = false;
  }

  // Format validation
  if (
    organization.value.phone &&
    !/^\d{3}-\d{3}-\d{4}$/.test(organization.value.phone)
  ) {
    errors.value.phone = "Phone number must be in format: 123-456-7890";
    isValid = false;
  }

  if (
    organization.value.zipcode &&
    !/^\d{5}$/.test(organization.value.zipcode)
  ) {
    errors.value.zipcode = "ZIP code must be 5 digits";
    isValid = false;
  }

  return isValid;
};

const isTabComplete = (tabId: string) => {
  switch (tabId) {
    case "general":
      return !!organization.value.name && !!organization.value.city;
    case "grades":
      return true;
    case "location":
      return true;
    case "groups":
      return true;
    default:
      return false;
  }
};

const formatPhoneNumber = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/\D/g, ""); // Remove non-digits

  if (value.length > 0) {
    if (value.length <= 3) {
      // No formatting needed for first 3 digits
    } else if (value.length <= 6) {
      value = `${value.slice(0, 3)}-${value.slice(3)}`;
    } else {
      value = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }
  }

  organization.value.phone = value;
};

const timeFields: string[] = [
  "defaultStartTime",
  "defaultEndTime",
  "earlyDismissalStartTime",
  "earlyDismissalEndTime",
  "emergencyStartTime",
  "emergencyEndTime",
  "shortenedDayStartTime",
  "shortenedDayEndTime",
];

const validateTimeFields = () => {
  let valid = true;
  for (const field of timeFields) {
    if (!organization.value[field as string]) {
      errors.value[field as string] = "This time field is required";
      valid = false;
    } else {
      errors.value[field as string] = "";
    }
  }
  return valid;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _createVNode(_component_router_link, { to: "/organizations" }, {
        default: _withCtx(() => [
          _createTextVNode("Schools")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
        return _createElementVNode("div", {
          key: tab.id,
          class: _normalizeClass(["step", {
          active: selectedTab.value === tab.id,
          completed: isTabComplete(tab.id),
        }]),
          onClick: ($event: any) => (selectedTab.value = tab.id)
        }, [
          _createElementVNode("div", _hoisted_7, [
            (isTabComplete(tab.id))
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "✓"))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(tab.number), 1))
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(tab.label), 1)
        ], 10, _hoisted_6)
      }), 64))
    ]),
    _createElementVNode("form", {
      onSubmit: _withModifiers(createOrganization, ["prevent"]),
      class: "add-form"
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((organization.value.name) = $event)),
                id: "name",
                name: "name",
                required: "",
                class: _normalizeClass({ error: errors.value.name })
              }, null, 2), [
                [_vModelText, organization.value.name]
              ]),
              (errors.value.name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(errors.value.name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((districtSearch).value = $event)),
                    onFocus: _cache[2] || (_cache[2] = ($event: any) => (showDistrictDropdown.value = true)),
                    placeholder: 
                      organization.value.districtName || 'Search districts...'
                    ,
                    class: _normalizeClass(["district-search-input", { 'has-value': organization.value.districtName }])
                  }, null, 42, _hoisted_22), [
                    [_vModelText, districtSearch.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "district-dropdown-toggle",
                    onClick: toggleDistrictDropdown
                  }, _toDisplayString(showDistrictDropdown.value ? "▼" : "▶"), 1)
                ]),
                (showDistrictDropdown.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDistricts.value, (district) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: district.id,
                          class: _normalizeClass(["district-option", {
                      selected: district.name === organization.value.districtName,
                    }]),
                          onClick: ($event: any) => (selectDistrict(district))
                        }, _toDisplayString(district.name), 11, _hoisted_24))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (organization.value.districtName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(organization.value.districtName), 1))
                  : _createCommentVNode("", true)
              ]),
              (errors.value.districtName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(errors.value.districtName), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((organization.value.organizationType) = $event)),
                id: "organizationType",
                name: "organizationType",
                required: "",
                class: _normalizeClass({ error: errors.value.organizationType })
              }, _hoisted_35, 2), [
                [_vModelSelect, organization.value.organizationType]
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((organization.value.organizationCode) = $event)),
                id: "organizationCode",
                name: "organizationCode",
                required: "",
                class: _normalizeClass({ error: errors.value.organizationCode })
              }, null, 2), [
                [_vModelText, organization.value.organizationCode]
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", _hoisted_39, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((organization.value.isActive) = $event)),
                  id: "isActive"
                }, null, 512), [
                  [_vModelCheckbox, organization.value.isActive]
                ]),
                _hoisted_40
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((organization.value.defaultStartTime) = $event)),
                name: "defaultStartTime",
                step: "300",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, organization.value.defaultStartTime]
              ]),
              (errors.value.defaultStartTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(errors.value.defaultStartTime), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((organization.value.defaultEndTime) = $event)),
                name: "defaultEndTime",
                step: "300",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, organization.value.defaultEndTime]
              ]),
              (errors.value.defaultEndTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(errors.value.defaultEndTime), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((organization.value.earlyDismissalStartTime) = $event)),
                name: "earlyDismissalStartTime",
                step: "300",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, organization.value.earlyDismissalStartTime]
              ]),
              (errors.value.earlyDismissalStartTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(errors.value.earlyDismissalStartTime), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((organization.value.earlyDismissalEndTime) = $event)),
                name: "earlyDismissalEndTime",
                step: "300",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, organization.value.earlyDismissalEndTime]
              ]),
              (errors.value.earlyDismissalEndTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(errors.value.earlyDismissalEndTime), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((organization.value.emergencyStartTime) = $event)),
                name: "emergencyStartTime",
                step: "300",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, organization.value.emergencyStartTime]
              ]),
              (errors.value.emergencyStartTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(errors.value.emergencyStartTime), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((organization.value.emergencyEndTime) = $event)),
                name: "emergencyEndTime",
                step: "300",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, organization.value.emergencyEndTime]
              ]),
              (errors.value.emergencyEndTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(errors.value.emergencyEndTime), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((organization.value.shortenedDayStartTime) = $event)),
                name: "shortenedDayStartTime",
                step: "300",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, organization.value.shortenedDayStartTime]
              ]),
              (errors.value.shortenedDayStartTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(errors.value.shortenedDayStartTime), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _withDirectives(_createElementVNode("input", {
                type: "time",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((organization.value.shortenedDayEndTime) = $event)),
                name: "shortenedDayEndTime",
                step: "300",
                autocomplete: "off",
                required: ""
              }, null, 512), [
                [_vModelText, organization.value.shortenedDayEndTime]
              ]),
              (errors.value.shortenedDayEndTime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(errors.value.shortenedDayEndTime), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("div", _hoisted_73, [
                _withDirectives(_createElementVNode("input", {
                  ref_key: "addressInput",
                  ref: addressInput,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((organization.value.address) = $event)),
                  id: "address",
                  name: "address",
                  required: "",
                  class: _normalizeClass([{ error: errors.value.address }, "address-input"]),
                  placeholder: "Start typing address..."
                }, null, 2), [
                  [_vModelText, organization.value.address]
                ]),
                (autocomplete.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_75, [
              _hoisted_76,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((organization.value.city) = $event)),
                id: "city",
                name: "city",
                required: "",
                class: _normalizeClass({ error: errors.value.city })
              }, null, 2), [
                [_vModelText, organization.value.city]
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              _hoisted_78,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((organization.value.state) = $event)),
                id: "state",
                name: "state",
                required: "",
                class: _normalizeClass({ error: errors.value.state })
              }, [
                _hoisted_79,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(states, (state) => {
                  return _createElementVNode("option", {
                    key: state,
                    value: state
                  }, _toDisplayString(state), 9, _hoisted_80)
                }), 64))
              ], 2), [
                [_vModelSelect, organization.value.state]
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((organization.value.zipcode) = $event)),
                id: "zipcode",
                name: "zipcode",
                required: "",
                pattern: "[0-9]{5}",
                maxlength: "5",
                class: _normalizeClass({ error: errors.value.zipcode })
              }, null, 2), [
                [_vModelText, organization.value.zipcode]
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              _hoisted_84,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((organization.value.phone) = $event)),
                id: "phone",
                name: "phone",
                type: "tel",
                required: "",
                pattern: "[0-9]{3}-[0-9]{3}-[0-9]{4}",
                placeholder: "123-456-7890",
                class: _normalizeClass({ error: errors.value.phone }),
                onInput: formatPhoneNumber,
                maxlength: "12"
              }, null, 34), [
                [_vModelText, organization.value.phone]
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((organization.value.website) = $event)),
                id: "website",
                type: "url",
                placeholder: "https://example.com"
              }, null, 512), [
                [_vModelText, organization.value.website]
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, selectedTab.value === 'general']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _hoisted_89,
          _createElementVNode("div", _hoisted_90, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(gradesList, (grade) => {
              return _createElementVNode("div", {
                key: grade.key,
                class: "grade-item"
              }, [
                _createElementVNode("label", {
                  for: grade.key,
                  class: "grade-label"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((organization.value[grade.key]) = $event),
                    id: grade.key
                  }, null, 8, _hoisted_92), [
                    [_vModelCheckbox, organization.value[grade.key]]
                  ]),
                  _createElementVNode("span", _hoisted_93, _toDisplayString(grade.label), 1)
                ], 8, _hoisted_91)
              ])
            }), 64))
          ])
        ])
      ], 512), [
        [_vShow, selectedTab.value === 'grades']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _hoisted_96,
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("div", _hoisted_98, [
              _hoisted_99,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((organization.value.latitude) = $event)),
                id: "latitude",
                type: "number",
                step: "0.000001"
              }, null, 512), [
                [_vModelText, organization.value.latitude]
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _hoisted_101,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((organization.value.longitude) = $event)),
                id: "longitude",
                type: "number",
                step: "0.000001"
              }, null, 512), [
                [_vModelText, organization.value.longitude]
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, selectedTab.value === 'location']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_102, [
        _createElementVNode("div", _hoisted_103, [
          _hoisted_104,
          _createElementVNode("div", _hoisted_105, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organization.value.groups, (group, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "group-card"
              }, [
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("h4", null, "Group " + _toDisplayString(index + 1), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "remove-group-btn",
                    onClick: ($event: any) => (removeGroup(index))
                  }, " × ", 8, _hoisted_107)
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("label", {
                      for: 'groupName' + index
                    }, "Group Name", 8, _hoisted_110),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((group.name) = $event),
                      id: 'groupName' + index
                    }, null, 8, _hoisted_111), [
                      [_vModelText, group.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("label", {
                        for: 'bellTime' + index
                      }, "Bell Time", 8, _hoisted_114),
                      _withDirectives(_createElementVNode("input", {
                        type: "time",
                        "onUpdate:modelValue": ($event: any) => ((group.bellTime) = $event),
                        id: 'bellTime' + index,
                        name: 'bellTime' + index
                      }, null, 8, _hoisted_115), [
                        [_vModelText, group.bellTime]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("label", {
                        for: 'dismissalTime' + index
                      }, "Dismissal Time", 8, _hoisted_117),
                      _withDirectives(_createElementVNode("input", {
                        type: "time",
                        "onUpdate:modelValue": ($event: any) => ((group.dismissalTime) = $event),
                        id: 'dismissalTime' + index,
                        name: 'dismissalTime' + index
                      }, null, 8, _hoisted_118), [
                        [_vModelText, group.dismissalTime]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                      _createElementVNode("label", {
                        for: 'startDate' + index
                      }, "Start Date", 8, _hoisted_121),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": ($event: any) => ((group.startDate) = $event),
                        id: 'startDate' + index
                      }, null, 8, _hoisted_122), [
                        [_vModelText, group.startDate]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("label", {
                        for: 'endDate' + index
                      }, "End Date", 8, _hoisted_124),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        "onUpdate:modelValue": ($event: any) => ((group.endDate) = $event),
                        id: 'endDate' + index
                      }, null, 8, _hoisted_125), [
                        [_vModelText, group.endDate]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("label", {
                      for: 'pickupNotes' + index
                    }, "Pickup Notes", 8, _hoisted_127),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((group.pickupNotes) = $event),
                      id: 'pickupNotes' + index,
                      rows: "2"
                    }, null, 8, _hoisted_128), [
                      [_vModelText, group.pickupNotes]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("label", {
                      for: 'dropOffNotes' + index
                    }, "Drop-off Notes", 8, _hoisted_130),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((group.dropOffNotes) = $event),
                      id: 'dropOffNotes' + index,
                      rows: "2"
                    }, null, 8, _hoisted_131), [
                      [_vModelText, group.dropOffNotes]
                    ])
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("button", {
              type: "button",
              class: "add-group-btn",
              onClick: addGroup
            }, " + Add New Group ")
          ])
        ])
      ], 512), [
        [_vShow, selectedTab.value === 'groups']
      ]),
      _createElementVNode("div", _hoisted_132, [
        (!isFirstTab.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "secondary-button",
              onClick: previousTab
            }, [
              _hoisted_133,
              _createTextVNode(" Previous ")
            ]))
          : _createCommentVNode("", true),
        (!isLastTab.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "primary-button",
              onClick: nextTab
            }, [
              _createTextVNode(" Next "),
              _hoisted_134
            ]))
          : _createCommentVNode("", true),
        (isLastTab.value)
          ? (_openBlock(), _createElementBlock("button", _hoisted_135, " Create School "))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ]))
}
}

})